/* Copyright 2024 VMware, Inc. All rights reserved. -- VMware Confidential */
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LocalStorageService } from "@app/services";

// @formatter:off
@Component({
    selector: "setting-toggle",
    templateUrl: "./setting-toggle.component.html",
    styleUrls: ["./setting-toggle.component.scss"]
})
// @formatter:on
export class SettingToggleComponent implements OnInit {

    @Input()
    public key: string;

    @Input()
    public label: string;

    @Output()
    public valueChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    public settingValue: boolean = false;

    constructor(private localStorageService: LocalStorageService) {
    }

    public ngOnInit(): void {
        this.settingValue = this.localStorageService.getBooleanValue(this.key);
    }

    public settingChanged(): void {
        this.localStorageService.setObject(this.key, this.settingValue);
        this.valueChanged.emit(this.settingValue);
    }
}
